import { getDim, CANVAS_WIDTH, CANVAS_HEIGHT } from '../../common/tablePlacement/canvasConstants';
import { format } from '../../../heplers/format';

export const ReservationTooltip = ({ table, reservations, canvasRef, scale = 1, offset = { x: 0, y: 0 } }) => {
  if (!table || !canvasRef.current) return null;

  const rect = canvasRef.current.getBoundingClientRect();
  const dim  = getDim(table.shape, table.persons);
  const px   = offset.x + table.positionX * CANVAS_WIDTH  * scale;
  const py   = offset.y + table.positionY * CANVAS_HEIGHT * scale;
  const dw   = dim.w * scale;
  const dh   = dim.h * scale;

  const tableReservations = reservations.filter((r) =>
    r.tableReserved?.split('|').some((item) => item.split(',')[0] === String(table.id))
  );

  if (!tableReservations.length) return null;

  return (
    <div style={{
      position:     'fixed',
      zIndex:       9999,
      top:          rect.top  + py - dh / 2 - 10,
      left:         rect.left + px + dw / 2 + 8,
      background:   '#fff',
      border:       '1px solid #ccc',
      borderRadius: 6,
      padding:      '8px 10px',
      boxShadow:    '0 2px 8px rgba(0,0,0,.15)',
      fontSize:     14,
      pointerEvents:'none',
      minWidth:     140,
    }}>
      {tableReservations.map((r, i) => (
        <div key={i} style={{ marginBottom: i < tableReservations.length - 1 ? 6 : 0 }}>
          <strong>{r.title}</strong>
          <br />
          {format('time', r.timeSlots?.[0]?.startDateTime)}
        </div>
      ))}
    </div>
  );
};
